module.exports = __webpack_public_path__ + "img/no_worries_04.2071666d.png";